import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { OverlayModule } from '@angular/cdk/overlay';

// External Libraries
import { MtxButtonModule } from '@ng-matero/extensions/button';

// HTTP
import { HttpClientModule } from '@angular/common/http';
import { HttpInteceptorModule } from './http/http-interceptor.module';

// Library Stuff
import { DialogsModule } from '@library/common';
import { MaterialsModule } from '@library/common/materials';
import { PipesModule } from '@library/core/pipes';
import { AuthModule } from '@library/modules/auth';
import { ErrorsModule } from '@library/modules/errors';
import { UserAccessGuard } from '@library/modules/user';

// App Specific
import { AppMenuModule } from './components/menu/menu.module';

import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { NavigationGuard } from '@library/modules/navigation';


@NgModule( {
   declarations: [
      AppComponent,
   ],
   imports: [
      // Angular modules
      BrowserAnimationsModule,
      BrowserModule,
      FormsModule,
      HttpClientModule,
      OverlayModule,
      ReactiveFormsModule,
      RouterModule,

      // External Libraries
      MtxButtonModule,

      // Http interceptor module
      HttpInteceptorModule,

      // Base menu-bar
      AppMenuModule,

      // Base router module
      AppRoutingModule,

      // Library Stuff,
      AuthModule,
      DialogsModule,
      ErrorsModule,
      MaterialsModule,
      PipesModule,
   ],
   providers: [
      // Guards
      UserAccessGuard,

      Validators,
      NavigationGuard,
   ],
   bootstrap: [ AppComponent ]
} )
export class AppModule {
}
